import LandinngPage from "./components/LandinngPage";


function App() {
  return (
    <div>
   <LandinngPage />
    </div>
  );
}

export default App;
